<template>
  <div>
    <template v-if="form.type == 10">
      <div class="flex items-center">
        <input
          type="text"
          class="uk-input"
          placeholder="Min"
          autocomplete="off"
          v-model="between.start"
          name="id"
        />
        <input
          type="text"
          class="uk-input"
          placeholder="Max"
          autocomplete="off"
          v-model="between.end"
          name="id2"
        />
      </div>
    </template>
    <template v-else>
      <input type="text" class="uk-input" v-model="model" name="text" />
    </template>
  </div>
</template>

<script>
export default {
  name: "id",
  data() {
    return {
      model: null,
      between: {},
    };
  },
  props: ["input", "form", "value"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model,
      });
    },
    between() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.between,
      });
    },
  },
};
</script>

<style></style>
